import RingLoader from 'react-spinners/RingLoader';

export const AuthLoader = () => <RingLoader color="#cc6633" size={30} />;
